import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { billFromOrder } from "../../api/purchases";

const today = () => new Date().toISOString().slice(0, 10);

// تسجيل فاتورة المورّد مقابل أمر شراء (الاستلام له نموذجه الخاص أعلاه).
export const OrderFollowUp = ({ order, onDone }) => {
  const { t } = useTranslation();
  const [reference, setReference] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await billFromOrder({ order_id: order.id, date: today(), supplier_reference: reference });
      toast.success(t("purchases.billCreated"));
      onDone?.();
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code || t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard className="grid gap-3 p-4" data-testid="order-follow-up">
      <p className="label-xs">{t("purchases.recordBill")}</p>
      <div className="grid gap-3 sm:grid-cols-[2fr_auto]">
        <NeuInput data-testid="bill-reference" dir="ltr" placeholder={t("purchases.supplierInvoiceNo")}
                  value={reference} onChange={(e) => setReference(e.target.value)} />
        <NeuButton variant="primary" className="px-4 py-2 text-xs" data-testid="create-bill"
                   disabled={busy} onClick={run}>
          {t("purchases.recordBill")}
        </NeuButton>
      </div>
    </NeuCard>
  );
};
